import gql from 'graphql-tag';

export default gql`
  mutation RateItem($mealId: Int!, $rating: Float!, $labels: [String]) {
    me {
      dietMealRating(mealId: $mealId) {
        rateItem(rating: $rating, labels: $labels) {
          __typename
          ... on BasicMutationSuccess {
            code
          }
        }
      }
    }
  }
`;
